<template>
    <div class="flats-crm-section active" v-if="saleItem != null && flats != null && saleFilterParams != null" :class="{'inViewCheck' : inViewCheck}">
        <flatsFilterMobile v-if="isMobile"></flatsFilterMobile>
        <div class="container">
            <div class="land-section-title" v-if="salesCardPage != null">
                <h2>{{salesCardPage.land_site_section_titles.flats}}</h2>
                <flatsBtns v-if="!isMobile"></flatsBtns>
            </div>
            <flatsTopBar v-if="isMobile" :class="{'fixed-bar' : slicky, 'inViewCheck' : inViewCheck, 'banerOnline' : banerSystem != undefined && banerSystem.baner_system_active == 'true' && banerTopCoockieVisible == true}" id="flatsTopBar"></flatsTopBar>
            <flatsFilterDesctop v-if="salesCard != null && !isMobile"></flatsFilterDesctop>
            <transition name="fade" mode="out-in">
		        <flatsItemsGrid v-if="gridView"></flatsItemsGrid>
                <flatsItemsList v-else :mobileView="isMobile"></flatsItemsList>
            </transition>
            <flatsModal :mobileView="isMobile"></flatsModal>
            <div class="pagination-btns" v-if="flatsItems != null && flatsItems.length > 11 && !flatsEmptyMsg && !hidePaginBtn">
                <a href="#" @click.prevent="getMoreFlats">
                    <span v-if="globalLang != 'kz/'">Загрузить ещё</span> 
                    <span v-else>Тағы жүктеу</span>
                </a>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
	import flatsFilterDesctop from '@/components/flats-crm/flats-crm-filter-desctop.vue'
	import flatsItemsGrid from '@/components/flats-crm/flats-crm-items.vue'
	import flatsItemsList from '@/components/flats-crm/flats-crm-items-list.vue'
	import flatsBtns from '@/components/flats-crm/flats-crm-btns.vue'
	import flatsModal from '@/components/flats-crm/flats-crm-modal.vue'
    // mobile
	import flatsTopBar from '@/components/flats-crm/flats-crm-topbar-mobile.vue'
	import flatsFilterMobile from '@/components/flats-crm/flats-crm-filter-mobile.vue'

    export default {
        name: 'sale-land-flats',
        components: {
			flatsFilterDesctop,
            flatsItemsGrid,
            flatsItemsList,
            flatsBtns,
            flatsModal,
            flatsTopBar,
            flatsFilterMobile,
			// flatsCards,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                isMobile: false,
                inViewCheck: false,
                slicky: false,
                topOffetBar: 0,
                minusNum: 50,
                // for flats filter
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            saleItem: 'loadSaleCardItem',
            saleFilterParams: 'loadSalesFilterCardParams',
            salesCardFlats: 'loadFlatsCardsGlobal',
            salesCardFlatsDefault: 'loadFlatsCardsGlobalDefault',
            flatsFilterData: 'loadFlatsFilterData',
            paginPageNumber: 'loadPaginPageNumber',
            flats: 'loadSalesCardPage',
			gridView: 'loadLandFlatsGridView',
            banerSystem: 'loadBanerSystem',
            banerTopCoockieVisible: 'loadCockieBanerTopVisible',
            flatsItems: 'loadFlatsItems',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
            hidePaginBtn: 'loadHidePaginBtn',
        }),
        methods: {
            getMoreFlats() {
                const count = this.paginPageNumber + 1;
                this.$store.commit('UpdatePaginPageNumber', count);
                this.flatsFilterData.pageNumber = this.paginPageNumber;
                this.$store.dispatch('getFlatsByPagination', this.flatsFilterData);
            },
            slickyTopBar() {
                if (this.isMobile == true) {
                    // console.log(window.scrollY);
                    // console.log(this.topOffetBar, this.banerTopCoockieVisible, this.minusNum)
                    if (this.banerTopCoockieVisible == true) {
                        this.minusNum = 110;
                    } else {
                        this.minusNum = 50;
                    }
                    if (window.scrollY >= this.topOffetBar - this.minusNum) {
                        this.slicky = true;
                        // console.log(this.topOffetBar)
                    } else {
                        this.slicky = false;
                    }
                }
            },
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
            window.addEventListener('scroll', this.slickyTopBar);
        },
        destroyed() {
            window.removeEventListener('scroll', this.slickyTopBar);
        },
        mounted () {
            this.isMobileCheck();
            this.checkResize();
            this.$store.dispatch('getFlatsItems', {
                "complexCodes": [this.saleItem.crm_code],
                "linesOnPage": 12
            }).then((response) => {
                if (this.isMobile == true) {
                    this.topOffetBar = parseInt($('#flatsTopBar').offset().top);
                    setTimeout(() => {
                        this.inViewCheck = true;
                    }, 300);
                    this.slickyTopBar();
                }
            });
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-section.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-section-respond.scss';
</style>